/** @file Component that renders a date in a readable format relative to the current time. */
import * as moment from 'moment';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { datetime } from '@codegrade/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function getTitle(date, prefix) {
    const formattedDate = datetime.readableFormatDate(date);
    if (prefix == null || prefix === '') {
        return formattedDate;
    }
    return `${prefix} ${formattedDate}`;
}
export default tsx.component({
    functional: true,
    props: {
        date: p(Object).validator(moment.isMoment).required,
        tag: p.ofType().default('span'),
        titlePrefix: p(String).optional,
        withoutSuffix: p(Boolean).default(false),
        transformText: p.ofFunction().optional,
        argThreshold: p.ofType().optional,
    },
    /**
     * The render function for this component.
     *
     * @param h Vue's Hyperscript function.
     * @param ctx The Render context.
     * @returns The VNode containing the rendered relative time.
     */
    render(h, ctx) {
        const { date, withoutSuffix, titlePrefix, transformText, argThreshold } = ctx.props;
        const now = ctx.parent.$getRootInstance().$getNow(date);
        let body = datetime.diff(now, date).humanize(!withoutSuffix, argThreshold);
        if (transformText != null) {
            body = transformText(body);
        }
        return h(ctx.props.tag, {
            attrs: {
                title: getTitle(date, titlePrefix),
                ...ctx.data.attrs,
            },
            class: [ctx.data.class, ctx.data.staticClass],
            style: [ctx.data.style, ctx.data.staticStyle],
        }, [body]);
    },
});
